import { View } from '@react-pdf/renderer'

const PDFDivider = ({ thickness = 1, marginTop = 5, marginBottom = 5, style }) => (
  <View
    style={{
      height: thickness,
      width: '100%',
      backgroundColor: 'black',
      marginTop,
      marginBottom,
      ...style,
    }}
  />
)

export default PDFDivider
